import { render, staticRenderFns } from "./GenericTable.vue?vue&type=template&id=3879fc48&scoped=true"
import script from "./GenericTable.vue?vue&type=script&lang=js"
export * from "./GenericTable.vue?vue&type=script&lang=js"
import style0 from "./GenericTable.vue?vue&type=style&index=0&id=3879fc48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3879fc48",
  null
  
)

export default component.exports